var timeline = [
  {
    value: "0-6 months",
    label: "0-6 Months",
  },
  {
    value: "6-12 months",
    label: "6-12 Months",
  },
  {
    value: "1-2 year",
    label: "1-2 Year",
  },
  {
    value: "2-5 year",
    label: "2-5 Year",
  },
];

var industries = [
  {
    value: "commercial",
    label: "Commercial",
  },
  {
    value: "residential",
    label: "Residential",
  },
  {
    value: "architect",
    label: "Architect",
  },
];

var costs = [
  {
    value: "10000-20000 $",
    label: "10000-20000 $",
  },
  {
    value: "20000-50000 $",
    label: "20000-50000 $",
  },
  {
    value: "50000-100000 $",
    label: "100000-500000 $",
  },
];

export { timeline, costs, industries };
